import React from 'react'
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import SupplierProductApi from "../../../../Api/SupplierProductApi";
import {
    getApiHost,
    getResponseError,
    getUserDetailsCookie,
    storeProductsInSession
} from "../../../../Api/Utils/apiUtils";
import GridContainer from "../../../../Components/Form/GridContainer/GridContainer";
import {faEye} from "@fortawesome/free-solid-svg-icons";
import "../../../../bootstrap/bootstrap.min.css";
import {useHistory} from "react-router-dom";
import '../../../../Components/Form/Form.css'
import BusinessDetailsApi from "../../../../Api/BusinessDetailsApi";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";

const ManageProductsComponent = () => {
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [products, setProducts] = React.useState([]);
    React.useEffect(() => {
        const loadProducts = async () => {
            const user = getUserDetailsCookie();
            const userId = user.id;
            const businessDetailsResponse = await BusinessDetailsApi.getBusinessDetails(userId);
            const businessApiError = getResponseError(businessDetailsResponse);
            if(businessApiError){
                setErrorMessage(businessApiError);
            } else {
                const businessId = businessDetailsResponse.objectVal.id;//10492
                const response = await SupplierProductApi.getProductDetails(businessId);
                const supplierApiError = getResponseError(response);
                if(supplierApiError){
                    setErrorMessage(supplierApiError);
                } else {
                    const productList = response.objectVal;
                    productList.forEach(p => {
                        p.GetproductInfoImage.forEach(img => {
                            let imageUrl = img.imageUrl;
                            if (imageUrl.indexOf('upload') === 0) {
                                imageUrl = getApiHost() + '/' + imageUrl;
                            }
                            img.imageUrl = imageUrl;
                        });
                    });
                    setProducts(productList);
                    storeProductsInSession(productList);
                }
            }
        };
        loadProducts();
    }, []);

    const history = useHistory();
    const showProductDetails = productId =>{
        history.push("/product-details/"+productId);
    }

    return (
        <Section>
            <FormContainer>
                <Heading>Manage products</Heading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <GridContainer itemsPerRow={1}>
                    { products.map(( product , index) =>
                        <div className="product-list-container" key={index} onClick={() => showProductDetails(product.id)}>
                            <img src={product.GetproductInfoImage.length>0 ? product.GetproductInfoImage[0].imageUrl : './img/no-img.jpg'} alt="product"/>
                            <div className="product-info">
                                <label><b>{product.title}</b></label><br/>
                                <label>{product.categoryName}</label><br/>
                                <label>{product.description}</label><br/>
                                <div className="product-price">
                                    <label style={{marginRight:"15px"}}><b>${product.price}</b></label>
                                    <div style={{float:"right"}}>
                                        <FontAwesomeIcon icon={faEye}/>&nbsp;
                                        <label>{product.view?product.view:0}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </GridContainer>
            </FormContainer>
        </Section>
    )
}

export default ManageProductsComponent
